import { render, staticRenderFns } from "./Mindmap.pug?vue&type=template&id=aca263ea&lang=pug&external"
import script from "./Mindmap.js?vue&type=script&lang=js&external"
export * from "./Mindmap.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports